import { useSelector, shallowEqual } from 'react-redux';

import { selectFuelType } from 'state/fuel-type/fuel-type-slice';
import { useMeterType } from 'hooks/useMeterType';
import { hasSmartMetter } from '../utils';

export const useHasSmartMeter = () => {
  const { electricityMeter, gasMeter } = useMeterType();
  const fuelType = useSelector(selectFuelType, shallowEqual);

  return hasSmartMetter(fuelType, electricityMeter, gasMeter);
};
